import { getMessagingInstance } from "./firebase";
import { onMessage } from "firebase/messaging";

export const listenNotifications = async () => {
  const messaging = await getMessagingInstance();
  if (messaging) {
    onMessage(messaging, (payload) => {
      console.log("Message received:", payload);
      alert(payload.notification.title);
      window.location.reload();
    });
  }
};